import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "py-8 px-4 md:px-10 bg-racq-true-white w-full border-t border-racq-white" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "grid md:flex gap-5" }
const _hoisted_4 = { class: "ml-auto" }
const _hoisted_5 = { class: "mt-14 md:mt-4" }

import { FormProps } from '@/interfaces';
import { Image, Link, Text, RichText } from '@sitecore-jss/sitecore-jss-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelfServiceFooter',
  props: {
    componentDir: {},
    errorComponent: {},
    rendering: {},
    fields: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields.childItems, (link, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_unref(Link), {
              field: link.fields.link,
              class: "text-racq-grey text-base-bold no-underline hover:!underline hover:!decoration-[10%]"
            }, null, 8, ["field"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Image), {
          media: _ctx.fields.rightLogo?.value,
          class: "ml-auto",
          width: "105",
          height: "26.7",
          alt: "racq logo"
        }, null, 8, ["media"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(RichText), {
        field: _ctx.fields.copyright
      }, null, 8, ["field"])
    ])
  ]))
}
}

})